import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Bestcabserviceinpune() {



const cardData = {
  keyword: " Best Cabs Service in Pune",

"headingDescription": "SRS Cab Service is the best cab service in Pune, offering reliable and comfortable travel solutions for airport transfers, business trips, family outings, and leisure travel. With SRS Taxi Pune, you get professional drivers, well-maintained vehicles, and punctual pickups ensuring a safe and smooth journey. Our SRS Pune Cab Booking service provides flexible options including one-way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. Choose SRS Airport Cab for hassle-free airport transfers and enjoy convenient online booking with 24/7 customer support.",
"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Visitors using SRS Cab Service in Pune often explore Shaniwar Wada, a historic fort known for its grand architecture and Maratha heritage. SRS Taxi Pune ensures a comfortable ride to this landmark, making it easy to admire the gates, ruins, and cultural significance."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is a must-visit for travelers using SRS Cab Service. Known for its connection to Mahatma Gandhi and India’s freedom movement, SRS Pune Cab Booking provides a convenient and safe way to reach this serene landmark and explore its gardens and museum exhibits."
  },
  {
    "title": "Sinhagad Fort",
    "description": "For trekking enthusiasts, Sinhagad Fort is a popular destination with panoramic views. Using SRS Taxi Pune, travelers can enjoy a hassle-free ride to this historic fort, combining adventure with the comfort of reliable cab service."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "Dagdusheth Halwai Ganpati Temple is one of Pune’s most revered temples. Visitors using SRS Cab Service can easily reach this spiritual site, seek blessings, and experience Pune’s vibrant devotional culture with convenience and safety."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple, an ancient rock-cut temple dedicated to Lord Shiva, is a peaceful historical site in Pune. SRS Pune Cab Booking allows travelers to enjoy a comfortable ride while exploring its unique carvings and serene surroundings."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses exquisite Indian artifacts. Visitors using SRS Cab Service in Pune can easily access this museum, appreciating traditional craftsmanship and Pune’s cultural heritage with the convenience of reliable transportation."
  },
  {
    "title": "Parvati Hill Temple",
    "description": "Parvati Hill Temple offers panoramic views of Pune and historic temples. Travelers using SRS Taxi Pune can reach this heritage site comfortably, enjoying both scenic beauty and spiritual exploration with top cab service reliability."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam is ideal for relaxing and enjoying nature. With SRS Cab Service, visitors can easily plan a trip to this serene location, capturing scenic photographs and enjoying peaceful walks without worrying about transportation."
  },
  {
    "title": "Pune Okayama Friendship Garden",
    "description": "Pune Okayama Friendship Garden, also known as Pu La Deshpande Garden, is a beautiful Japanese-style garden. Travelers booking through SRS Pune Cab Booking can enjoy a calm and leisurely visit with hassle-free cab service."
  },
  {
    "title": "Lal Mahal",
    "description": "Lal Mahal is a historic palace linked to the childhood of Chhatrapati Shivaji Maharaj. SRS Taxi Pune ensures visitors can explore this landmark conveniently, learning about Maratha history and enjoying the architecture with reliable cab service."
  }
],



services: [
{
name: "Reliable Cab Service Pune",
description: "Reliable cab service Pune offers dependable transportation for local and outstation travel. Customers can expect timely pickups and safe journeys with experienced drivers. Clean and well-maintained vehicles ensure comfort throughout the ride. Ideal for daily commuting, airport transfers, and long-distance trips. Transparent pricing makes it trustworthy for regular use. Choose reliable cab services in Pune for hassle-free travel."
},
{
name: "Affordable Best Cabs in Pune",
description: "Affordable best cabs in Pune provide budget-friendly travel without compromising comfort. Customers can choose economical vehicles for local and outstation trips. Professional drivers ensure smooth and safe journeys. Transparent pricing ensures no hidden charges. Ideal for students, families, and daily commuters. Travel smartly with affordable cab services in Pune."
},
{
name: "Luxury Cab Service Pune",
description: "Luxury cab service Pune offers premium travel experience with high-end vehicles. Customers can enjoy comfortable rides with professional chauffeurs. Ideal for corporate travel, weddings, and special occasions. Spacious interiors and advanced features enhance comfort. Flexible booking options suit different needs. Experience luxury travel with top cab services in Pune."
},
{
name: "Pune Best Car Service",
description: "Pune best car service provides high-quality transportation solutions for all travel needs. Customers can book vehicles for city rides, airport transfers, and outstation trips. Professional drivers ensure safe and timely journeys. Multiple vehicle options ensure flexibility. Affordable pricing adds convenience. Choose the best car service in Pune for smooth travel."
},
{
name: "Highly Rated Cab Service Pune",
description: "Highly rated cab service Pune offers trusted transportation with excellent customer reviews. Customers can expect punctual service and well-maintained vehicles. Professional drivers ensure safe and comfortable travel. Ideal for business and personal use. Transparent pricing ensures reliability. Book highly rated cab services in Pune for quality travel."
},
{
name: "Pune Best Taxi Booking",
description: "Pune best taxi booking service provides quick and easy cab reservations. Customers can book taxis online for local and outstation travel. Professional drivers ensure smooth journeys. Multiple vehicle options suit different budgets. Transparent pricing ensures fair fares. Enjoy convenient taxi booking services in Pune."
},
{
name: "Top-Rated Cab Service Pune",
description: "Top-rated cab service Pune offers premium transportation with high customer satisfaction. Customers can enjoy reliable pickups and smooth rides. Professional drivers ensure safe travel across Pune. Ideal for daily commuting and long trips. Affordable pricing adds value for money. Choose top-rated cab services in Pune for better travel experience."
},
{
name: "Pune Elite Taxi Service",
description: "Pune elite taxi service provides premium transportation for luxury and corporate travel. Customers can choose high-end vehicles with professional drivers. Ideal for business meetings and special events. Comfortable seating ensures a pleasant ride experience. Flexible booking options add convenience. Experience elite travel with Pune taxi services."
},
{
name: "Best 24/7 Cab Service Pune",
description: "Best 24/7 cab service Pune offers round-the-clock transportation for all travel needs. Customers can book cabs anytime for airport or local travel. Professional drivers ensure safe journeys at any hour. Multiple vehicle options provide flexibility. Transparent pricing ensures fair charges. Travel anytime with reliable 24/7 cab services in Pune."
},
{
name: "Pune Premium Taxi Service",
description: "Pune premium taxi service provides high-quality transportation with comfort and reliability. Customers can choose premium vehicles for business and personal travel. Professional drivers ensure safe and smooth journeys. Ideal for airport transfers and long trips. Transparent pricing ensures value for money. Experience premium taxi services in Pune."
},
{
name: "Best Pune Taxi Providers",
description: "Best Pune taxi providers offer trusted and reliable transportation services. Customers can book cabs for local and outstation travel easily. Professional drivers ensure timely pickups and safe journeys. Multiple vehicle options suit different needs. Affordable pricing makes it convenient. Choose the best taxi providers in Pune for hassle-free travel."
},
{
name: "Recommended Cab Service Pune",
description: "Recommended cab service Pune provides trusted travel solutions with excellent customer feedback. Customers can expect reliable service and comfortable rides. Professional drivers ensure safe travel across routes. Ideal for daily commuting and long-distance journeys. Transparent pricing ensures affordability. Book recommended cab services in Pune confidently."
},
{
name: "Best Cab Service in Pune",
description: "Best cab service in Pune offers complete transportation solutions for local and outstation travel. Customers can choose from a wide range of vehicles. Professional drivers ensure safe and timely journeys. Transparent pricing ensures budget-friendly rides. Ideal for business and family travel. Choose the best cab service in Pune for smooth journeys."
},
{
name: "Best Cab Service Pune to Mumbai",
description: "Best cab service Pune to Mumbai provides reliable intercity travel via expressway routes. Customers can enjoy comfortable vehicles for long journeys. Professional drivers ensure safe and timely travel. One-way and round trip options are available. Affordable pricing ensures value for money. Travel easily between Pune and Mumbai with top cab services."
},
{
name: "Best Outstation Cab Service in Pune",
description: "Best outstation cab service in Pune offers comfortable travel for long-distance journeys. Customers can book cabs for tourist and business trips. Professional drivers ensure safe highway travel. Multiple vehicle options provide flexibility. Transparent pricing ensures affordability. Choose outstation cab services in Pune for stress-free travel."
},
{
name: "Best Taxi Service in Pune",
description: "Best taxi service in Pune provides reliable transportation for all travel needs. Customers can book taxis for local and outstation trips easily. Professional drivers ensure safe journeys. Multiple vehicle options suit different budgets. Transparent pricing ensures fair fares. Enjoy the best taxi services in Pune for smooth travel."
},
{
name: "Best Cab Service Mumbai to Pune",
description: "Best cab service Mumbai to Pune offers smooth intercity travel with comfortable vehicles. Customers can book cabs for one-way or round trips. Professional drivers ensure safe and timely journeys. Affordable pricing ensures cost-effective travel. Easy booking options add convenience. Travel comfortably from Mumbai to Pune with best cab services."
},
{
name: "Best Cab Service from Mumbai Airport to Pune",
description: "Best cab service from Mumbai airport to Pune provides direct airport transfers with ease. Customers can book taxis for timely pickups from terminals. Comfortable vehicles ensure smooth journeys. Professional drivers track flights for punctual service. Transparent pricing ensures affordability. Book airport cab services for stress-free travel."
},
{
name: "Best Cab Service from Pune to Goa",
description: "Best cab service from Pune to Goa offers long-distance travel with comfort and reliability. Customers can enjoy scenic routes with professional drivers. Comfortable vehicles ensure smooth journeys. One-way and round trip options are available. Affordable pricing makes travel convenient. Travel from Pune to Goa with trusted cab services."
},
{
name: "Best Cab Service from Pune to Mumbai Airport",
description: "Best cab service from Pune to Mumbai airport provides reliable airport transfers. Customers can book cabs for direct drop to airport terminals. Professional drivers ensure timely arrivals. Comfortable vehicles enhance travel experience. Transparent pricing ensures fair fares. Travel stress-free with Pune to Mumbai airport cab services."
},
{
name: "Best Mumbai Pune Cab Service",
description: "Best Mumbai Pune cab service offers reliable transportation between the two cities. Customers can choose from multiple vehicle options. Professional drivers ensure smooth and safe journeys. One-way and round trip options are available. Affordable pricing ensures value for money. Travel easily between Mumbai and Pune with top cab services."
},
{
name: "Best Pune to Mumbai Cab Service",
description: "Best Pune to Mumbai cab service provides seamless travel for business and leisure trips. Customers can enjoy comfortable rides via expressway routes. Professional drivers ensure timely travel. Flexible booking options suit different needs. Transparent pricing ensures affordability. Choose the best Pune to Mumbai cab services for hassle-free journeys."
},
{
name: "Trusted Cab Service Pune",
description: "Trusted cab service Pune offers safe and dependable transportation for all travel needs. Customers can rely on experienced drivers and well-maintained vehicles. Ideal for daily commuting and long trips. Transparent pricing ensures trust and reliability. Easy booking options add convenience. Choose trusted cab services in Pune for worry-free travel."
},
{
name: "Affordable Cab Service Pune",
description: "Affordable cab service Pune provides cost-effective travel solutions for local and outstation trips. Customers can choose economical vehicle options. Professional drivers ensure safe and smooth journeys. Transparent pricing ensures no hidden charges. Ideal for budget travelers. Travel affordably with cab services in Pune."
},
{
name: "Cheap Cab Service Pune",
description: "Cheap cab service Pune offers low-cost transportation for daily commuting and long-distance travel. Customers can book cabs at competitive rates. Professional drivers ensure safe travel. Clean vehicles provide comfortable rides. Flexible booking options add convenience. Choose cheap cab services in Pune for budget travel."
},
{
name: "Premium Cab Service Pune",
description: "Premium cab service Pune provides high-quality travel with comfortable vehicles. Customers can enjoy smooth rides with professional drivers. Ideal for business and personal travel. Clean interiors enhance travel experience. Transparent pricing ensures value for money. Choose premium cab services in Pune for better comfort."
},
{
name: "Professional Cab Service Pune",
description: "Professional cab service Pune offers reliable transportation with trained drivers. Customers can expect punctual service and smooth journeys. Ideal for corporate and personal travel needs. Multiple vehicle options provide flexibility. Transparent pricing ensures affordability. Choose professional cab services in Pune for dependable travel."
}
],

tableData: [
["Reliable Cab Service Pune","Affordable Best Cabs in Pune"],
["Luxury Cab Service Pune","Pune Best Car Service"],
["Highly Rated Cab Service Pune","Pune Best Taxi Booking"],
["Top-Rated Cab Service Pune","Pune Elite Taxi Service"],
["Best 24/7 Cab Service Pune","Pune Premium Taxi Service"],
["Best Pune Taxi Providers","Recommended Cab Service Pune"],
["Best Cab Service in Pune","Best Cab Service Pune to Mumbai"],
["Best Outstation Cab Service in Pune","Best Taxi Service in Pune"],
["Best Cab Service Mumbai to Pune","Best Cab Service from Mumbai Airport to Pune"],
["Best Cab Service from Pune to Goa","Best Cab Service from Pune to Mumbai Airport"],
["Best Mumbai Pune Cab Service","Best Pune to Mumbai Cab Service"],
["Trusted Cab Service Pune","Affordable Cab Service Pune"],
["Cheap Cab Service Pune","Premium Cab Service Pune"],
["Professional Cab Service Pune","Reliable Cab Service Pune"]
],





whychoose: [
  {
    WhyChooseheading: "Top-Rated Cab Service in Pune",
    WhyChoosedescription: "SRS Cab Service is recognized as one of the best cab services in Pune, offering reliable rides, professional drivers, and excellent customer satisfaction for both local and outstation travel."
  },
  {
    WhyChooseheading: "Affordable & Competitive Pricing",
    WhyChoosedescription: "We provide the best cab service in Pune at affordable rates with transparent pricing. Customers enjoy budget-friendly travel without any hidden charges."
  },
  {
    WhyChooseheading: "24/7 Reliable Cab Service",
    WhyChoosedescription: "SRS Cab Service operates 24/7 to provide the best cab service in Pune for airport transfers, local rides, corporate travel, and outstation trips anytime."
  },
  {
    WhyChooseheading: "Clean, Sanitized & Comfortable Vehicles",
    WhyChoosedescription: "Our fleet consists of clean, well-maintained, and air-conditioned vehicles to ensure maximum comfort and hygiene for every journey."
  },
  {
    WhyChooseheading: "Wide Range of Premium Vehicles",
    WhyChoosedescription: "Choose from sedan cars, SUVs like Ertiga and Innova, luxury Innova Crysta, and Tempo Travellers, making us the best cab service in Pune for all travel needs."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Pune",
    WhyChoosedescription: "We provide convenient pickup from homes, offices, hotels, and Pune Airport across all areas including Hinjewadi, Baner, Wakad, Kharadi, and Hadapsar."
  },
  {
    WhyChooseheading: "Flexible Travel Options",
    WhyChoosedescription: "SRS Cab Service offers one-way, round-trip, hourly rental, and full-day cab services, giving customers complete flexibility in travel planning."
  },
  {
    WhyChooseheading: "Trusted & Professional Service",
    WhyChoosedescription: "Thousands of customers trust SRS Cab Service as the best cab service in Pune due to our punctuality, professional drivers, and consistent quality service."
  }
]
}

const faqData = [
  { question: "Which is the best cab service in Pune?", answer: "SRS Cab Service is one of the best cab services in Pune known for reliable service, professional drivers, and affordable pricing." },
  { question: "Is cab service in Pune available 24/7?", answer: "Yes, SRS Cab Service is available 24 hours a day for local, airport, and outstation travel." },
  { question: "What types of cabs are available in Pune?", answer: "We offer sedan cars, SUVs, Innova Crysta, and Tempo Travellers for different travel needs." },
  { question: "Do you provide Pune Airport cab service?", answer: "Yes, we provide timely airport pickup and drop services in Pune." },
  { question: "Can I book a cab for outstation travel?", answer: "Yes, we provide outstation cab services from Pune to Mumbai, Shirdi, Nashik, Mahabaleshwar, and more." },
  { question: "Are your cabs clean and sanitized?", answer: "Yes, all our vehicles are regularly cleaned and sanitized for passenger safety." },
  { question: "Do you offer one-way cab service?", answer: "Yes, we provide one-way and round-trip cab services at affordable rates." },
  { question: "How can I book a cab in Pune?", answer: "You can book easily online or call us for quick cab booking in Pune." },
  { question: "Do you provide corporate cab services?", answer: "Yes, we offer corporate cab services in Pune for office travel and business needs." },
  { question: "Are your drivers professional?", answer: "Yes, all our drivers are experienced, trained, and professional." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Aniket Jadhav",
    feedback:
      "SRS Cab Service is truly the best cab service in Pune. Clean car, polite driver, and on-time service.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Pooja Sharma",
    feedback:
      "Very reliable and affordable cab service in Pune. I always prefer SRS for airport and outstation trips.",
    rating: 5
  }
];



































const Images = [
{ place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "Pune-Cab-Service" },
{ place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "Pune-Taxi-Hire" },
{ place: "/images/keyword/3.jpg", text: "Pune Online Cabs Booking", link: "Pune-Online-Cabs-Booking" },
{ place: "/images/keyword/4.jpg", text: "Best Cabs Service in Pune", link: "Best-Cabs-Service-in-Pune" },
{ place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cab", link: "Pune-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab", link: "Pune-to-Lonavala-Cab" },
{ place: "/images/keyword/9.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Pune to Shirdi Cab", link: "Pune-to-Shirdi-Cab" },
{ place: "/images/keyword/11.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
{ place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cab", link: "Pune-to-Konkan-Darshan-Cab" },
{ place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
{ place: "/images/keyword/15.jpg", text: "Pune Outstation Cabs", link: "Pune-Outstation-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab", link: "Pune-to-Panchgani-Cab" },
{ place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
{ place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab", link: "Ashtavinayak-Darshan-Cab" },
{ place: "/images/keyword/19.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Goa Cab", link: "Pune-to-Goa-Cab" },
{ place: "/images/keyword/21.jpg", text: "Pune to Ajanta Ellora Cab", link: "Pune-to-Ajanta-Ellora-Cab" },
{ place: "/images/keyword/22.jpg", text: "Pune to Satara Cabs", link: "Pune-to-Satara-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Pune Airport Cabs", link: "Pune-Airport-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Pune to Ayodhya Tour Package", link: "Pune-to-Ayodhya-Tour-Package" },
{ place: "/images/keyword/25.jpg", text: "Corporate Cab Service in Pune", link: "Corporate-Cab-Service-in-Pune" },
];














const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Best Cab Service in Pune | SRS Cab",
  "description": "SRS Cab offers the best cab service in Pune, including reliable, affordable, and luxury cabs. We provide top-rated Pune taxi booking, 24/7 cab services, premium and elite taxi options, and outstation trips from Pune to Mumbai, Mumbai Airport, and Goa. Enjoy safe, comfortable, and punctual rides with highly rated drivers and online booking.",
  "brand": {
    "@type": "Brand",
    "name": "SRS Cab"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.srscabservice.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2450"
  }
};





  return (
    <div>
      
<Helmet>
  <title>Best Cab Service in Pune | Call +91 9011955415 | SRS Cab</title>
  <meta 
    name="description" 
    content="Book the best cab service in Pune with SRS Cab. Reliable, affordable, luxury, and top-rated cabs. Pune to Mumbai, Mumbai Airport, Goa trips with 24/7 online booking available." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/4.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#030706', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Srs Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2 d-flex">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
               <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Srs Cab Service</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Srs Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                        //   title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919011955415" className="pc-call">+91 9011955415</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919011955415"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919011955415" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@srscabservice.com" className="pc-email">
        booking@srscabservice.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Srs Cab Service</strong><br />
        Office no. 3 Mankar corner, kaspate chowk wakad Pune 411027
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Bestcabserviceinpune;